if (!customElements.get('wlsn-product-recommendations')) {
  class WLSNProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        loaded: 'wlsn-product-recommendations--loaded',
        complementary: 'complementary-products',
      };

      this.selectors = {
        recommendations: 'wlsn-product-recommendations',
        gridItem: '.grid__item',
        slider: 'wlsn-slider',
      };
    }

    /**
     * Get dataset attributes
     * @returns {object} - Configuration object with data attributes
     */
    get config() {
      return {
        productId: this.dataset.productId,
        sectionId: this.dataset.sectionId,
        url: this.dataset.url,
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this._loadRecommendations();
    }

    /**
     * Fetch and render product recommendations from server
     * @returns {void}
     */
    _loadRecommendations() {
      const { productId, sectionId, url } = this.config;

      if (!productId || !sectionId || !url) {
        console.error('Product recommendations: Missing required data attributes');
        return;
      }

      const requestUrl = `${url}&product_id=${productId}&section_id=${sectionId}`;

      fetch(requestUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((text) => {
          this._renderRecommendations(text);
        })
        .catch((error) => {
          console.error('Failed to load product recommendations:', error);
        });
    }

    /**
     * Parse and render recommendations HTML
     * @param {string} html - The HTML response from server
     * @returns {void}
     */
    _renderRecommendations(html) {
      const container = document.createElement('div');
      container.innerHTML = html;

      const recommendations = container.querySelector(this.selectors.recommendations);
      const sectionStylesheet = container.querySelector('style[data-section-stylesheet]');

      // Replace content if recommendations exist, preserving its response-scoped CSS.
      if (recommendations?.innerHTML.trim().length) {
        this.innerHTML = `${sectionStylesheet?.outerHTML || ''}${recommendations.innerHTML}`;
      }

      // Remove complementary products if no slider component
      if (!this.querySelector(this.selectors.slider) && this.classList.contains(this.classes.complementary)) {
        this.remove();
        return;
      }
    }
  }

  customElements.define('wlsn-product-recommendations', WLSNProductRecommendations);
}
